import * as THREE from "three";
import { Artwork, ArtworkWrapper } from "@/types/artworksData";
import * as LightUtils from "./light.utils";
import { ArtworkPedestal } from "../loaders/artwork/attachments/pedestal.attachment";
import * as ProceduralSpaceUtils from "./procedural.utils";
import * as ResourceUtils from "./resource.utils";
import * as GeneralUtils from "./general.utils";
import * as GeometryUtils from "./geometry.utils";
import * as MaterialsUtils from "./materials.utils";

export class Utils {
  constructor() { }

  public checkForPropInArray(propName: string, data: string[]) {
    return GeneralUtils.checkForPropInArray(propName, data);
  }

  public loadLight(light: any, appData: any) {
    return LightUtils.loadLight(light, appData);
  }

  public removeLight(index: number, appData: any) {
    return LightUtils.removeLight(index, appData);
  }

  public adjustValue(currentValue: number, min: number, max: number, change: number) {
    return GeneralUtils.adjustValue(currentValue, min, max, change);
  }

  public createLights(lights: any, appData: any) {
    return LightUtils.createLights(lights, appData);
  }

  public removeLights(appData: any) {
    return LightUtils.removeLights(appData);
  }

  public disposeOfChildren(obj, selfKeep?) {
    return ResourceUtils.disposeOfChildren(obj, selfKeep);
  }

  public addPedestalsToPhysicsCollection(pedestal: THREE.Mesh) {
    return ArtworkPedestal.addPedestalsToPhysicsCollection(pedestal);
  }

  public removePedestalsFromPhysicsCollection(pedestal: THREE.Mesh) {
    return ArtworkPedestal.removePedestalsFromPhysicsCollection(pedestal);
  }

  public handleProcedrualWallCollision(appData: any) {
    return ProceduralSpaceUtils.handleProcedrualWallCollision(appData);
  }

  public handleProceduralSpaceVisibility(appData: any) {
    return ProceduralSpaceUtils.handleProceduralSpaceVisibility(appData);
  }

  public handleArtworksVisibilityForProcedrualSpace(appData: any) {
    return ProceduralSpaceUtils.handleArtworksVisibilityForProcedrualSpace(appData);
  }

  public createPedestal(loadedMesh: any, artworkData: ArtworkWrapper, slot: THREE.Object3D) {
    return ArtworkPedestal.createPedestal(loadedMesh, artworkData, slot);
  }

  public applyHighQualityHints() {
    return GeneralUtils.applyHighQualityHints();
  }

  public updatePedestalType(artwork: Artwork) {
    return ArtworkPedestal.updatePedestalType(artwork);
  }

  public updatePedestalColor(color: string, artwork: Artwork) {
    return ArtworkPedestal.updatePedestalColor(color, artwork);
  }

  public updatePedestalGeometry(pedestalMesh: any, slot: THREE.Object3D, selectedArtwork: any) {
    return ArtworkPedestal.updatePedestalGeometry(pedestalMesh, slot, selectedArtwork);
  }

  public getFileType(url: string): 'png' | 'jpg' | 'mp4' | null {
    return GeneralUtils.getFileType(url);
  }

  public getObjectDimensions(object: THREE.Object3D | THREE.Scene | THREE.Group | THREE.Mesh) {
    return GeometryUtils.getObjectDimensions(object);
  }

  public sortByIndex(elements: any[]): any[] {
    return GeneralUtils.sortByIndex(elements);
  }

  public scaleMeshToMatchHeight(object: any, height: number) {
    return GeometryUtils.scaleMeshToMatchHeight(object, height);
  }

  public getSlotObjectBySlotTarget(slotTarget: number, appData: any) {
    return GeneralUtils.getSlotObjectBySlotTarget(slotTarget, appData);
  }

  public sortByDistanceToCamera(artworkWrappers: any[], cameraPosition: THREE.Vector3) {
    return GeneralUtils.sortByDistanceToCamera(artworkWrappers, cameraPosition);
  }

  public fixFBXMaterials(fbx: any) {
    return MaterialsUtils.fixFBXMaterials(fbx);
  }


}
